import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";

export default function Transportadora(props) {
  const [transporadoraId] = useState(Number(props.match.params.id));
  const history = props.history;
  const [carregando, setCarregando] = useState(false);
  const [freteSelecionado, setFreteSelecionado] = useState(false);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(false);
  const [transportadora, setTransportadora] = useState({});
  const [frete, setFrete] = useState({});
  const [condicao, setCondicao] = useState({});
  const [servicosFrete, setServicosFrete] = useState([]);
  const [condicoes, setCondicoes] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (transporadoraId > 0) {
      carregarTranspotadora();
    }
  }, []);

  const carregarTranspotadora = () => {
    setCarregando(true);

    api
      .get("transportadoras/carregar", { id: transporadoraId })
      .then((res) => {
        if (res.inativacao) res.inativacao = res.inativacao.split(" ")[0];
        setTransportadora(res);
        setCarregando(false);
        listarServicosFrete();
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar transportadora");
        setCarregando(false);
      });
  };

  const listarServicosFrete = () => {
    api
      .get("transportadoras/listarServicosFrete", {
        transportadoraId: transporadoraId,
      })
      .then((res) => {
        setServicosFrete(res);
      })
      .catch((err) => {
        notification(
          "error",
          "Erro ao listar os serviços de frete da transportadora."
        );
      });
  };

  const salvar = (params) => {
    setTransportadora(params);

    if (transporadoraId === 0) {
      api
        .put("transportadoras/inserir", params)
        .then((res) => {
          notification("success", "Transportadora inserida!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      params.id = transporadoraId;
      api
        .post("transportadoras/editar", params)
        .then((res) => {
          notification("success", "Transportadora editada!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const camposDados = () => {
    const campos = {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: transportadora.nome,
      },
    };

    campos.inativacao = {
      label: "Inativação",
      type: "date",
      value: transportadora.inativacao,
      space: 6,
    };

    return campos;
  };

  const fDados = {
    title:
      transporadoraId > 0 ? "Editar transportadora" : "Nova transportadora",
    form: camposDados(),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const abrirDados = (registro) => {
    setFrete(registro);
    setFreteSelecionado(true);

    api
      .get("transportadoras/carregarServicoFrete", { id: registro.id })
      .then((res) => {
        res.condicoes.forEach((r) => {
          r.valorExibir = (r.valor / 100).toFixed(2);
        });
        setCondicoes(res.condicoes);
      })
      .catch((err) => {
        return notification("error", "Erro ao carregar dados serviços frete ");
      });
  };

  const tServicosFrete = {
    title: "Serviços de frete",
    onLineClick: abrirDados,
    columns: [
      {
        label: "Descrição",
        name: "descricao",
      },
    ],
    array: servicosFrete,
    newItemAction: () => setFreteSelecionado(true),
  };

  const alterarServicoFrete = (params) => {
    if (!frete.id) {
      api
        .put("transportadoras/inserirServicoFrete", {
          descricao: params.descricao,
          inativacao: params.inativacao,
          transportadoraId: transporadoraId,
        })
        .then((res) => {
          notification("success", "Serviço frete inserido!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Descrição inválida");
            case 2:
              return notification("error", "Transportadora inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("transportadoras/editarServicoFrete", {
          id: frete.id,
          descricao: params.descricao,
          inativacao: params.inativacao,
        })
        .then((res) => {
          notification("success", "Serviço frete editado!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Descrição inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fFrete = {
    title: frete.id ? "Editar Serviço De Frete" : "Incluir Serviço De Frete",
    form: {
      descricao: {
        label: "Descrição",
        type: "text",
        value: frete.descricao,
        space: 6,
      },
      inativacao: {
        label: "Data de inativação",
        type: "date",
        value: frete.inativacao,
        space: 6,
      },
    },

    submit: {
      label: "salvar",
      action: alterarServicoFrete,
    },
    close: {
      label: "Fechar",
      action: () => {
        setFreteSelecionado(false);
        setFrete({});
      },
    },
  };

  const alterarCondicao = (params) => {
    if (!condicao.id) {
      api
        .put("transportadoras/inserirServicoFreteCondicao", {
          servicoFreteId: frete.id,
          valor: (params.valor * 100).toFixed(2),
          pesoMaximo: params.pesoMaximo,
          prazoDias: params.prazoDias,
        })
        .then((res) => {
          notification("success", "Serviço condição de frete inserido!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Serviço de frete inválido");
            case 2:
              return notification("error", "Valor inválido");
            case 3:
              return notification("error", "Peso máximo inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("transportadoras/editarServicoFreteCondicao", {
          id: condicao.id,
          valor: (params.valor * 100).toFixed(2),
          pesoMaximo: params.pesoMaximo,
          prazoDias: params.prazoDias,
        })
        .then((res) => {
          notification("success", "Serviço condição de frete editado!");
          setTransportadora({});
          history.push(`/app/transportadora`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Valor inválido");
            case 2:
              return notification("error", "Peso máximo inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const removerCondicao = () => {
    api
      .delete("transportadoras/removerServicoFreteCondicao", {
        id: condicao.id,
      })
      .then((res) => {
        notification("success", "Serviço condição de frete removido!");
        setTransportadora({});
        history.push(`/app/transportadora`);
      })
      .catch((err) => {
        return notification("error", "Erro ao remover condição");
      });
  };

  const fCondicao = {
    title: condicao.id ? "Editar Condição" : "Incluir Condição",
    form: {
      valor: {
        label: "Valor (R$)",
        type: "number",
        // value: condicao.valor,
        value: (condicao.valor / 100).toFixed(2),
        space: 4,
      },
      pesoMaximo: {
        label: "Peso máximo (kg)",
        type: "number",
        value: condicao.pesoMaximo,
        space: 4,
      },
      prazoDias: {
        label: "Prazo (dias)",
        type: "number",
        value: condicao.prazoDias,
        space: 4,
      },
    },

    submit: {
      label: "salvar",
      action: alterarCondicao,
    },
    close: {
      label: "Fechar",
      action: () => {
        setCondicaoSelecionada(false);
        setCondicao({});
      },
    },

    customActions: condicao.id
      ? [
          {
            label: "Remover condição",
            action: () => removerCondicao(),
          },
        ]
      : undefined,
  };

  const abrirCondicoes = (registro) => {
    setCondicao(registro);
    setCondicaoSelecionada(true);
  };

  const tCondicoes = {
    title: "Condições",
    array: condicoes,
    onLineClick: abrirCondicoes,
    columns: [
      {
        name: "valorExibir",
        label: "Valor (R$)",
      },
      {
        name: "pesoMaximo",
        label: "Peso máximo (kg)",
      },
      {
        name: "prazoDias",
        label: "Prazo (dias)",
      },
    ],
    newItemAction: () => setCondicaoSelecionada(true),
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fDados} />}

      {!freteSelecionado ? (
        <>
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tServicosFrete} />
          )}
        </>
      ) : (
        <>
          <Form formData={fFrete} />

          {!condicaoSelecionada ? (
            <>
              <ActionTable structure={tCondicoes} />
            </>
          ) : (
            <Form formData={fCondicao} />
          )}
        </>
      )}
    </div>
  );
}
